import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-search-supplier',
  templateUrl: './search-supplier.component.html',
  styleUrls: ['./search-supplier.component.css']
})
export class SearchSupplierComponent implements OnInit {

  private dp = [];
  displayedColumns = ['supplier_no', 'supplier_name', 'supplier_name_en', 'city_name', 'mobile', 'tax_no', 'choose'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'supplier', 'supplier_name': '', 'supplier_no': '', 'mobile': '', 'phone1': '', 'tax_no': '' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SearchSupplierComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }


  ngOnInit() {
  }

  search() {

    let condition = "";

    if (this.model['supplier_name'] != '')
      condition = " AND (`supplier`.`supplier_name` LIKE '%" + this.model['supplier_name'] +
        "%' OR `supplier`.`supplier_name_en` LIKE '%" + this.model['supplier_name'] + "%')";

    if (this.model['supplier_no'] != '')
      condition += " AND `supplier`.`supplier_no` LIKE '%" + this.model['supplier_no'] + "%'";

    if (this.model['mobile'] != '')
      condition += " AND `supplier`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['phone1'] != '')
      condition += " AND (`supplier`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `supplier`.`phone2` LIKE '%" + this.model['phone1'] + "%')";

    if (this.model['tax_no'] != '')
      condition += " AND `supplier`.`tax_no` LIKE '%" + this.model['tax_no'] + "%'";

    let query = "SELECT `supplier`.*, `city`.`city_name`, `country`.`country_id` FROM `supplier`, `city`, `country` WHERE `supplier`.`city_id` = `city`.`city_id`"
      + condition + " AND `city`.`country_id` = `country`.`country_id` AND `supplier`.`status` = '1'";

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  chooseSup(row) {
    this.dialog_data = {
      'supplier_name': row.supplier_name,
      'supplier_id': row.supplier_id,
      'supplier_no': row.supplier_no,
      'mobile': row.mobile
    };
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
